<template>
  <div v-if="shuffled.length > batchSizeDefault"
       @mouseover="stopRotation()"
       @mouseout="startRotation()"
       class="member-carrousel-box">
    <h6 v-if="headline">{{ headline }}</h6>
    <transition name="slide-left" mode="out-in">
      <ul class="row" :key="currentIndex">
        <li v-for="member in computedList" :key="'member' + (member ? member.id : '')" class="col-4 col-md-2">
          <tracker a="impression" tn="member" :tr="member.id">
            <a :href="member.href">
              <img :src="member.logo" :alt="member.company" loading="lazy"/>
            </a>
          </tracker>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  name: "member-carrousel-box",
  props: {
    headline: {
      type: String
    },
    value: {
      type: Array,
      required: true
    },
    shuffle: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      contextPath: window.contextPath,
      ready: false,
      shuffled: [],
      rotation: null,
      currentIndex: 0,
      batchSizeDefault: 6
    };
  },
  created: function () {
    if (this.shuffle) {
      for (var i = 0; i < this.value.length; i++) {
        this.shuffled.splice(
            Math.floor(Math.random() * (this.shuffled.length + 1)),
            0,
            this.value[i]);
      }
    } else {
      for (var j = 0; j < this.value.length; j++) {
        this.shuffled.push(this.value[j]);
      }
    }
    this.startRotation();
  },
  computed: {
    computedList: function () {
      var result = [];
      for (let i = 0; i < this.batchSize; i++) {
        result.push(this.shuffled[(this.currentIndex + i) % this.shuffled.length]);
      }
      return result;
    },
    batchSize: function () {
      return xs() ? 3 : this.batchSizeDefault;
    }
  },
  methods: {
    incrementIndex() {
      this.currentIndex = (this.currentIndex + this.batchSize) % this.shuffled.length;
    },
    startRotation: function () {
      if (this.shuffled.length > 6) {
        this.rotation = setInterval(() => {
          this.incrementIndex();
        }, 5000);
      }
    },
    stopRotation: function () {
      clearInterval(this.rotation);
      this.rotation = null;
    }
  }
}
</script>

<style lang="less">
.member-carrousel-box {
  overflow: hidden;
  margin-bottom: 2rem;

  h6 {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 0;
  }

  ul {
    height: calc(9.5rem + var(--bs-border-width));
    list-style: none;
    padding: 0;

    li {
      height: calc(9.5rem + var(--bs-border-width));

      a {
        border-bottom: var(--bs-border-width) solid var(--nm-grey-10);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 9.5rem;

        img {
          margin: auto;
          max-width: 100%;
        }
      }
    }
  }
}
</style>